import { RootingInterests } from '../types/types';
import { useSessionCache, hashKey } from './useSessionCache';

export function buildRootingCacheKey(
  playerName: string,
  playerPicks: string,
  knownWinners: string[],
  pointsPerRound: number[],
  roundNames: string[]
): string {
  return hashKey(JSON.stringify({ playerName, playerPicks, knownWinners, pointsPerRound, roundNames }));
}

export function useRootingCache() {
  return useSessionCache<RootingInterests>('rooting_cache_', 'rooting_cache_order');
}
